import React from 'react';
import { MessageCircle, Clock, CheckCircle } from 'lucide-react';

const CTA = () => {
  return (
    <section style={{
      padding: '120px 40px',
      background: 'radial-gradient(ellipse at center, rgba(212, 175, 55, 0.15) 0%, transparent 70%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '600px',
        height: '600px',
        background: 'radial-gradient(circle, rgba(212, 175, 55, 0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        filter: 'blur(100px)'
      }} />

      <div style={{ maxWidth: '900px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div className="fade-in" style={{ textAlign: 'center' }}>
          <h2 style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: '56px',
            fontWeight: '800',
            lineHeight: '1.2',
            marginBottom: '30px'
          }}>
            Pronto Para <span className="gold-gradient">Revolucionar</span><br />
            Sua Presença Digital?
          </h2>
          <p style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '20px',
            fontWeight: '300',
            color: '#CCCCCC',
            marginBottom: '50px',
            lineHeight: '1.8'
          }}>
            Não perca mais vendas por ter um site fraco ou inexistente.
            Entre em contato agora e solicite seu orçamento personalizado.
          </p>

          {/* Benefits */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '30px',
            marginBottom: '50px'
          }}>
            {[
              { icon: <Clock size={32} />, text: 'Entrega Rápida' },
              { icon: <CheckCircle size={32} />, text: '100% Garantido' },
              { icon: <MessageCircle size={32} />, text: 'Suporte 24/7' }
            ].map((item, idx) => (
              <div key={idx} style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '15px'
              }}>
                <div style={{ color: '#D4AF37' }}>
                  {item.icon}
                </div>
                <span style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#FFFFFF'
                }}>
                  {item.text}
                </span>
              </div>
            ))}
          </div>

          {/* Main CTA */}
          <button
            onClick={() => window.open('https://wa.me/5562995664918?text=Olá! Quero revolucionar minha presença digital com a System!', '_blank')}
            className="btn-primary shimmer"
            style={{
              fontSize: '20px',
              padding: '20px 50px',
              marginBottom: '20px',
              animation: 'pulse 2s infinite'
            }}
          >
            SOLICITAR ORÇAMENTO AGORA
          </button>

          <p style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '14px',
            fontWeight: '400',
            color: '#999999'
          }}>
            Resposta em até 2 horas • Orçamento sem compromisso
          </p>
        </div>

        {/* Urgency banner */}
        <div className="fade-in" style={{
          marginTop: '60px',
          padding: '30px',
          background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.2) 0%, rgba(212, 175, 55, 0.05) 100%)',
          border: '2px solid rgba(212, 175, 55, 0.5)',
          borderRadius: '12px',
          textAlign: 'center',
          transitionDelay: '0.4s'
        }}>
          <p style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '16px',
            fontWeight: '600',
            color: '#D4AF37',
            letterSpacing: '1px',
            textTransform: 'uppercase'
          }}>
            ⚡ ATENÇÃO: Projetos iniciados este mês ganham 1 mês de manutenção grátis!
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          h2 {
            font-size: 36px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default CTA;